import React from 'react';

export type LandingIconCard = {
  key: string;
  icon: React.ReactNode;
  title: string;
  description: string;
};

export type LandingIconCardGridProps = {
  cards: LandingIconCard[];
};

const LandingIconCardGrid: React.FC<LandingIconCardGridProps> = ({ cards }) => (
  <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
    {cards.map((c) => (
      <div
        key={c.key}
        className="flex flex-col border border-slate-800 bg-slate-900/35 p-6 transition-colors hover:border-slate-600 md:p-8"
      >
        <div className="mb-4">{c.icon}</div>
        <h3 className="mb-3 text-lg font-semibold text-white">{c.title}</h3>
        <p className="flex-grow text-sm leading-relaxed text-slate-400">{c.description}</p>
      </div>
    ))}
  </div>
);

export default LandingIconCardGrid;
